import { useState, useEffect  } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';
import { EnumCalzada } from '../../../Utils/Enumeradores/ComunEnum';

const ModalElementos = ({ onHide, elemento, nombreModal, setTablaDatos, tablaDatos, data, isElemento, setHayCambiosModal, seleccionInicialRef, ...rest }) => { 
  const [seleccionTodo, setSeleccionTodo] = useState(true);
  const [elementosTemporalmenteMarcados, setElementosTemporalmenteMarcados] = useState({}); 

  const manejarSeleccionTodo = () => {
    const nuevaSeleccionTodo = !seleccionTodo;
  
    const ids = data.map((row) => {
      const id = isElemento ? row.idBIM : row.matrizHectometroId;
      return id; 
    });

    setElementosTemporalmenteMarcados((prev) => {
      const actualizado = { ...prev };

      ids.forEach((id) => {
        actualizado[id] = nuevaSeleccionTodo;
      });
  
      return actualizado;
    });

    setSeleccionTodo(nuevaSeleccionTodo);
  };
  
  const manejarCambio = (id) => {
    setElementosTemporalmenteMarcados((prev) => ({
      ...prev,
      [id]: !prev[id] 
    }));
  };
  

  const manejarConfirmar = () => {
    const seleccionActual = Object.keys(elementosTemporalmenteMarcados).filter(id => elementosTemporalmenteMarcados[id]);
    const hayDiferencias = JSON.stringify(seleccionInicialRef.current.sort()) !== JSON.stringify(seleccionActual.sort());

    setHayCambiosModal(hayDiferencias);

    setTablaDatos(prevTablaDatos =>
      prevTablaDatos.map(fila => {
        if (isElemento && fila.planElementos) {
          return {
            ...fila,
            planElementos: fila.planElementos.map(elemento => {
              if (elemento.idBIM in elementosTemporalmenteMarcados) {
                return { ...elemento, estado: elementosTemporalmenteMarcados[elemento.idBIM] };
              }
              return elemento;
            })
          };
        } else if (!isElemento && fila.planHectometros) {
          return {
            ...fila,
            planHectometros: fila.planHectometros.map(hectometro => {
              if (hectometro.matrizHectometroId in elementosTemporalmenteMarcados) {
                return { ...hectometro, estado: elementosTemporalmenteMarcados[hectometro.matrizHectometroId] };
              }
              return hectometro;
            })
          };
        }
        return fila;
      })
    );
  
    localStorage.setItem("elementosMarcados", JSON.stringify(elementosTemporalmenteMarcados));
    onHide();
  };

  useEffect(() => {
    if (rest.show) {
      if (seleccionInicialRef.current === null) {
        seleccionInicialRef.current = tablaDatos
          .flatMap(fila => isElemento ? fila.planElementos : fila.planHectometros)
          .filter(dato => dato.estado)
          .map(dato => isElemento ? dato.idBIM : dato.matrizHectometroId);
      }
    }
  }, [rest.show]);

  useEffect(() => {
    const estadosIniciales = tablaDatos.reduce((row, fila) => {
      const propiedad = isElemento ? "planElementos" : "planHectometros";
      fila[propiedad]?.forEach((dato) => {
        const id = isElemento ? dato.idBIM : dato.matrizHectometroId;
        row[id] = dato.estado || false;
      });
      return row;
    }, {});
    setElementosTemporalmenteMarcados(estadosIniciales);
  }, [tablaDatos, isElemento]);

  return (
    <Modal {...rest} size="lg" centered keyboard={false}>
      <Modal.Header>
        <h5 className="modal-title">
          <span>{elemento ? 'Elementos' : 'Hectómetros'} Involucrados</span>
          <br />
          {nombreModal && <span className="modal-subtitle">{nombreModal}</span>}
        </h5>
        <Button
          type="button"
          design="btn-outline-pewter-blue p-2 lh-1 fs-3"
          onClick={onHide}
        >
          <i className="ico-close"></i>
        </Button>
      </Modal.Header>

      <Modal.Body className="p-4 gap-4 d-flex flex-column">
        <div
          className="accordion-body p-0 brd-top"
          style={{
            maxHeight: '235px',
            overflowY: 'scroll',
            border: '1px solid #ddd',
            scrollbarWidth: 'thin',
            scrollbarColor: '#ddd #fff'
          }}
        >
          <table
            className="table table-sm"
            border="1"
            style={{ width: '100%', textAlign: 'left', marginBottom: '0' }}
          >
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={seleccionTodo}
                    onChange={manejarSeleccionTodo}
                  />
                </th>
                <th>{elemento ? 'IdBIM' : 'Hectómetro'}</th>
                <th>{elemento ? 'Descripción' : 'Km Inicial Hectómetro'}</th>
                <th>{elemento ? 'Km Elemento' : 'Km Final Hectómetro'}</th>
                {elemento && <th>Calzada</th>}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => {
                const id = isElemento ? row.idBIM : row.matrizHectometroId;
                return (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={elementosTemporalmenteMarcados[id] || false}
                        onChange={() => manejarCambio(id)}
                      />
                    </td>
                    <td>{isElemento ? row.idBIM : row.hectometro}</td>
                    <td>{isElemento ? row.descripcion : row.pkInicialHectometro}</td>
                    <td>{isElemento ? row.kmElemento : row.pkFinalHectometro}</td>
                    {isElemento && <td>{EnumCalzada[row.calzada]}</td>}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <button onClick={manejarConfirmar} className="btn btn-primary">
            Confirmar {elemento ? 'Elementos' : 'Hectómetros'}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalElementos;
